import { ToastContainer } from "react-toastify";
import { useConfigurations } from "./hooks/useConfigurations";
import { filterConfigurations } from "./utils/configHelpers";
import EditMenu from "../EditMenu";
import ConfigTable from "./components/ConfigTable";
import ConfigurationControls from "./components/ConfigurationControls";
import ConfigurationDialogs from "./components/ConfigurationDialogs";
import { PageTitle } from "src/shared/PageTitle";
import { useEffect } from "react";
import { pageTitle } from "src/shared/utils/brand";

const Configurations = () => {
  const { configs, setConfigs, addConfig, editConfig, removeConfig } = useConfigurations();
  const filteredData = filterConfigurations(configs.list, configs.searchQuery);

  const handleEdit = (config: any) => setConfigs((prev: typeof configs) => ({ ...prev, currentConfig: config, openEdit: true }));

  const handleDelete = (config: any) => setConfigs((prev: typeof configs) => ({ ...prev, currentConfig: config, openDelete: true }));

  const addConfigurationsButton = { Blue: "blue", name: "Add Configuration" };

    useEffect(() => {
    document.title = pageTitle("Configurations › Settings");
  }, []);

  return (
    <div>
      <div className="flex flex-col w-[90vw] h-[89vh] items-center overflow-hidden">
        <PageTitle title="- Settings › Configurations" />
        <EditMenu editmenu={{ Configuration: "Configuration" }} />

        <ConfigurationControls configs={configs} setConfigs={setConfigs} AddConfigurationsButton={addConfigurationsButton} />

        <ConfigTable data={filteredData} onEdit={handleEdit} onDelete={handleDelete} />

        <ConfigurationDialogs configs={configs} setConfigs={setConfigs} addConfig={addConfig} editConfig={editConfig} removeConfig={removeConfig} />
        <ToastContainer />
      </div>
    </div>
  );
};

export default Configurations;
